import {createBrowserHistory} from 'history';

//create history for main Route:
const history=createBrowserHistory();

export {history};